import { Platform } from 'react-native'
import { SegmentedButtons } from 'react-native-paper'
import { withUnistyles } from 'react-native-unistyles'

/**
 * Web-specific fix for react-native-paper SegmentedButtons truncation.
 *
 * The library's SegmentedButtonItem has:
 * - flex: 1 on each button (equal-width split) - causes segments to shrink
 * - numberOfLines={1} on the Text - truncates when parent is constrained
 * - paddingHorizontal: 16 in the content row
 *
 * On RN Web, flex layout constrains the row width, so each segment gets ~half
 * and the Text truncates. We fix by:
 * 1. Overriding button flex so each segment sizes to its content
 * 2. Adding flexShrink: 0 to the label so Text doesn't shrink (forces parent to grow)
 * 3. alignSelf: 'flex-start' on container so it doesn't stretch to fill parent
 */
const isWeb = Platform.OS === 'web'

const UniSegmentedButtons = withUnistyles(
  (props: React.ComponentProps<typeof SegmentedButtons>) => {
    return (
      <SegmentedButtons
        {...props}
        buttons={props.buttons}
        style={isWeb ? [props.style, { minWidth: 300 }] : props.style}
      />
    )
  }
)

export default UniSegmentedButtons
